import g1 from "../Images/Games/g1.webp";
import g2 from "../Images/Games/g2.webp";
import g3 from "../Images/Games/g3.webp";
import g4 from "../Images/Games/g4.webp";
import g5 from "../Images/Games/g5.webp";
import g6 from "../Images/Games/g6.webp";
import g7 from "../Images/Games/g7.webp";
import g8 from "../Images/Games/g8.webp";
import g9 from "../Images/Games/g9.webp";
import g10 from "../Images/Games/g10.webp";
import g11 from "../Images/Games/g11.webp";
import g12 from "../Images/Games/g12.webp";

// landing image
import gM1 from "../Images/Games/gMain/gM1.jpeg";
import gM2 from "../Images/Games/gMain/gM2.png";
import gM3 from "../Images/Games/gMain/gM3.jpeg";
import gM4 from "../Images/Games/gMain/gM4.jpeg";
import gM5 from "../Images/Games/gMain/gM5.png";
import gM6 from "../Images/Games/gMain/gM6.webp";
import gM7 from "../Images/Games/gMain/gM7.jpeg";
import gM8 from "../Images/Games/gMain/gM8.png";
import gM9 from "../Images/Games/gMain/gM9.jpeg";
import gM10 from "../Images/Games/gMain/gM10.png";
import gM11 from "../Images/Games/gMain/gM11.jpeg";
import gM12 from "../Images/Games/gMain/gM12.jpeg";

export const gamesData = [
  {
    id: 1,
    imgB: gM1,
    img: g1,
    name: "Helldive₹™",
    price: "₹ 2,499",
  },
  {
    id: 2,
    imgB: gM2,
    img: g2,
    name: "Rise of the Ronin",
    price: "₹ 4,999",
  },
  {
    id: 3,
    imgB: gM9,
    img: g9,
    name: "Call of Duty: Modern Warfare III",
    price: "₹ 5,599",
  },
  {
    id: 4,
    price: "₹ 2,999",
    imgB: gM3,
    img: g3,
    name: "The Last of Us Part II Remastered",
  },
  { id: 5, price: "₹ 3,239", imgB: gM4, img: g4, name: "Tekken 8" },
  { id: 6, price: "₹ 4,499", imgB: gM5, img: g5, name: "EA SPORTS™ FC 24" },
  { id: 7, price: "₹ 4,399", imgB: gM6, img: g6, name: "Dragon's Dogma 2" },
  { id: 8, price: "₹ 3,639", imgB: gM7, img: g7, name: "Final Fantasy XVI" },
  { id: 9, price: "₹ 4,999", imgB: gM8, img: g8, name: "Marvel's Spider-Man 2" },
  {
    id: 10,
    price: "₹ 4,999",
    imgB: gM10,
    img: g10,
    name: "God of War Ragnarök",
  },
  {
    id: 11,
    price: "₹ 2,839",
    imgB: gM11,
    img: g11,
    name: "Final Fantasy VII Rebirth",
  },
  { id: 12, price: "₹ 999", imgB: gM12, img: g12, name: "LEGO Fortnite" },
];
